import React, {Component} from 'react';
import {Button, Grid, Paper, Typography} from "@material-ui/core";
import TextFieldDefault from "../../../../Components/TextFieldDefaultComponent/TextFieldDefault";
import ItemSkUs from "./ItemSKUs";
import SpacerComponent from "../../../../Components/SpacerComponent/SpacerComponent";
import {InstantFormContext} from "../../../../Contexts/InstantFormContext";
import {ContentSKUStyled, InfoSKUStyled} from "../styled";

class SkUs extends Component {
    static contextType = InstantFormContext;

    constructor(props) {
        super(props);

        this.state = {
            itens: [],
            formData: null,
        };
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (this.context.isEdit === false && this.state.itens.length <= 0) {
            this.setState({
                itens: [
                    <ItemSkUs/>,
                ]
            });
            return;
        }

        if (this.context.formData.products === undefined) {
            return;
        }

        if (this.state.formData === this.context.formData) {
            return;
        }

        const itens = [];

        this.context.formData.products.map((value) => {
            itens.push(
                <ItemSkUs value={{
                    sku: value.product_name,
                    qtd: value.amount,
                }}
                          isEdit={this.context.isEdit}/>
            );
        });

        this.setState({
            itens,
            formData: this.context.formData,
        });
    }

    add = () => {

        const itens = this.state.itens;
        itens.push(
            <ItemSkUs/>
        );

        this.setState({
            itens,
        });
    }

    remove = () => {
        const itens = this.state.itens.splice(1);

        this.setState({
            itens,
        });

        this.context.removeSKUSChildsContext();
    }

    render() {
        return (
            <ContentSKUStyled variant={'outlined'}>
                <Typography variant={'subtitle2'}
                            align={'center'}
                            color={'primary'}>
                    Combinação de Nomes
                </Typography>
                <InfoSKUStyled variant={'body2'}
                               align={'center'}
                               color={'error'}>
                    * Cadastre seu cód. interno conforme aparece na nota fiscal. (Letras maiúsculas e minúsculas serão
                    consideradas, assim como acentos, pontos e qualquer outro caractere especial).
                </InfoSKUStyled>
                <SpacerComponent height={20}/>
                <Grid container={true}
                      direction={'row'}
                      justify="center"
                      alignItems="center">
                    {this.state.itens}
                </Grid>
                <Button variant={'outlined'}
                        color={'primary'}
                        fullWidth={true}
                        disabled={this.context.isEdit}
                        onClick={this.add}>Adicionar Produto</Button>
                <SpacerComponent height={20}/>
                <Button variant={'outlined'}
                        color={'primary'}
                        fullWidth={true}
                        disabled={this.context.isEdit}
                        onClick={this.remove}>Remover último Produto</Button>
            </ContentSKUStyled>
        );
    }
}

export default SkUs;